import React from 'react'
import ReactMixin from 'react-mixin'
import ImmutableRenderMixin from 'react-immutable-render-mixin'
import Input from '_/shared/components/input'
import { Map, List } from 'immutable'
import getDisplayName from '_/utils/getDisplayName'

/**
 * Associated properties
 */
@ReactMixin.decorate(ImmutableRenderMixin)
class AssociatedProperties extends React.Component {
  static propTypes = {
    currentProperty: React.PropTypes.object.isRequired,
    editable: React.PropTypes.bool,
    properties: React.PropTypes.object.isRequired,
    onChange: React.PropTypes.func.isRequired
  }

  handleOptions (data) {
    return data.map(r => {
      return { value: r.get('id'), label: `${getDisplayName('property', r)} - ${r.get('pid')}` }
    }).toJS()
  }

  handleChange (_, multi) {
    this.props.onChange(List(multi.map(opt => Map({
      id: opt.value,
      address: opt.label
    }))))
  }

  render() {
    const { editable, properties, currentProperty } = this.props

    // If the only property and not editing, do not show
    if (!editable && properties.size <= 1) return null

    if (!editable) {
      const additionalProperties = properties
        .filter(property => property.get('id') !== currentProperty.get('id'))

      return (
        <div>
          <br/>
          <p>This is a multi-parcel transaction which also includes the following properties:</p>
          <ul>
            {additionalProperties.map((p, idx) =>
              <li key={idx}>
                <a href={`/records/${p.get('id')}`}>{getDisplayName('property', p)}</a>
              </li>
            )}
          </ul>
        </div>
      )
    }

    // Editable
    return (
      <div>
        <br/>
        <Input
            multi
            type="select-ajax"
            value={properties.map(p => p.get('id')).toJS()}
            options={properties
              .map(p => ({ value: p.get('id'), label: getDisplayName('property', p) }))
              .toJS()}
            onChange={::this.handleChange}
            handleOptions={::this.handleOptions}
            name="properties"
            url="/records?minimal=true"
            label="Associated properties" />
      </div>
    )
  }
}

export default AssociatedProperties



// WEBPACK FOOTER //
// ./modules/shared/pages/record/associatedProperties.js